// /src/services/statusValidationApi.js

import { client } from "./axiosClient";

/**
 * API para validação de status da One Page
 * Usa a nova infraestrutura de regras de status do backend
 */

/**
 * Valida o status de uma One Page contra as regras calculadas
 * @param {string} initiativeId - ID da iniciativa
 * @param {string} onePageId - ID da One Page (opcional, para edição)
 * @param {string} status - Status reportado pelo usuário
 * @returns {Promise<Object>} Resultado da validação com warnings
 */
export const validateOnePageStatus = async (
  initiativeId,
  onePageId = null,
  status = null,
) => {
  try {
    const payload = {
      initiative_id: initiativeId,
      onepage_id: onePageId,
      status: status,
    };

    const response = await client.post(
      "/api/validate-onepage-status/",
      payload,
    );

    if (response.data.success) {
      return {
        success: true,
        data: response.data.data,
        hasWarning: response.data.data.has_warning,
        warningMessage: response.data.data.warning_message,
        warningDetails: response.data.data.warning_details,
        calculatedStatus: response.data.data.calculated_status,
      };
    } else {
      return {
        success: false,
        error: response.data.error || "Erro na validação do status",
        hasWarning: false,
      };
    }
  } catch (error) {
    console.error("Erro na validação do status:", error);
    return {
      success: false,
      error:
        error.response?.data?.error || "Erro na comunicação com o servidor",
      hasWarning: false,
    };
  }
};

/**
 * Calcula o status que deveria ser baseado nas regras
 * @param {string} initiativeId - ID da iniciativa
 * @returns {Promise<Object>} Status calculado
 */
export const calculateOnePageStatus = async (initiativeId) => {
  try {
    const response = await client.get(
      `/api/calculate-onepage-status/${initiativeId}/`,
    );

    if (response.data.success) {
      return {
        success: true,
        calculatedStatus: response.data.data.calculated_status,
        statusSource: response.data.data.status_source,
      };
    } else {
      return {
        success: false,
        error: response.data.error || "Erro no cálculo do status",
      };
    }
  } catch (error) {
    console.error("Erro no cálculo do status:", error);
    return {
      success: false,
      error:
        error.response?.data?.error || "Erro na comunicação com o servidor",
    };
  }
};
